import PmgTeamIcon from "../../../assets/pmg_team_icon.svg";
import UpdateIcon from "../../../assets/pmg_updates_icon.svg";
import ResourceIcon from "../../../assets/Resource_Menu.svg";
const PmgTeamDropDownOptions = [
  {
    title: "PMG Team",
    icon: PmgTeamIcon,
    expandView: true,
    dropDown: [
      {
        id: 1,
        title: "DPIIT",
        keyName: "DPIIT"
      },
      {
        id: 2,
        title: "PMG Invest India",
        keyName: "PMG_INVEST_INDIA"
      },
      {
        id: 3,
        title: "Section",
        keyName: "section"
      }
    ]
  },
  {
    id: 4,
    title: "Updates",
    icon: UpdateIcon,
    keyName: "PMG_Updates"
  },
  // {
  //   title: "Resources",
  //   icon: ResourceIcon,
  //   expandView: true,
  //   dropDown: [
  //     {
  //       id: 5,
  //       title: "Best Practices",
  //       keyName: "BEST_PRACTICES"
  //     },
  //     {
  //       id: 6,
  //       title: "Notifications",
  //       keyName: "NOTIFICATIONS"
  //     }
  //   ]
  // },
  {
    id: 7,
    title: "Under Maintenance",
    icon: "Under Maintenance",
    expandView: false
  }
];

export { PmgTeamDropDownOptions };
